import React from 'react';
import classNames from 'classnames';
import { LineItem } from '../../hooks/useCart/cart.rest';
import { LineItemMini } from '../LineItem';
import { hasError } from './hasError';
import './LineItemListMini.scss';

type Props = {
  granularity?: 'minimal' | 'full';
  theme?: 'box' | 'simple';
  title?: string;
  items: LineItem[];
};

export const LineItemListMini: React.FC<Props> = ({
  granularity = 'full',
  theme = 'box',
  title,
  items
}) => (
  <div
    className={classNames(
      'LineItemListMini',
      `LineItemListMini--${granularity}`,
      `LineItemListMini--${theme}`,
      {
        'LineItemListMini--error': hasError(items)
      }
    )}
  >
    {title && <h6 className="LineItemListMini__title">{title}</h6>}
    {items.map(item => (
      <div key={item.id} className="LineItemListMini__item">
        <LineItemMini granularity={granularity} item={item} />
      </div>
    ))}
  </div>
);
